import {ConfigService, ErrorsService, ModelsList, StoreService, Taggable} from 'shared';
import {Tag} from 'shared';
import {HttpClient, HttpParams} from '@angular/common/http';
import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';

@Injectable({
  deps: [HttpClient],
  providedIn: 'root'
})
export class TagService extends StoreService<Tag> {

  constructor(http: HttpClient, config: ConfigService, errors: ErrorsService) {
    super(http, config, errors);
    this.initStore(Tag);
  }

  protected load(queryParams?: HttpParams): Observable<ModelsList<Tag>> {
    return this.http.get<ModelsList<Tag>>(this.config.apiVerUrl('/app/tags'), {params: queryParams});
  }

  protected insert(values: Tag): Observable<number> {
    return this.http.post<number>(this.config.apiVerUrl('/app/tags'), values);
  }

  protected remove(id): Observable<void> {
    return this.http.delete<void>(this.config.apiVerUrl(`/app/tags/${id}`));
  }

  protected update(id, values): Observable<Tag> {
    return this.http.put<Tag>(this.config.apiVerUrl(`/app/tags/${id}`), values);
  }

  public checkCode(code: number, id?: number): Observable<boolean> {
    return this.http.post<boolean>(this.config.apiVerUrl('/app/tags/check-code'), {code, id});
  }

  taggable(id): Observable<Taggable> {
    return this.http.get<Taggable>(this.config.apiVerUrl(`/app/tags/${id}/taggable`));
  }

}
